import React, { useEffect, useId } from 'react';
import { X } from 'lucide-react';

export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  footer,
  size = 'md',
  className = '',
  closeOnBackdrop = true,
  closeOnEscape = true,
}) {
  const titleId = useId();
  const descId = useId();

  useEffect(() => {
    if (!isOpen || !closeOnEscape) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, closeOnEscape, onClose]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="bza-modal-backdrop"
      onClick={closeOnBackdrop ? onClose : undefined}
      role="dialog"
      aria-modal="true"
      aria-labelledby={title ? titleId : undefined}
      aria-describedby={description ? descId : undefined}
    >
      <div
        className={`bza-modal-window bza-modal-window-${size} ${className}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bza-modal-header">
          <div>
            {title && (
              <h2 id={titleId} className="bza-modal-title">
                {title}
              </h2>
            )}
            {description && (
              <p id={descId} className="bza-modal-description">
                {description}
              </p>
            )}
          </div>
          <button
            type="button"
            className="bza-modal-close"
            onClick={onClose}
            aria-label="Close dialog"
          >
            <X size={18} />
          </button>
        </div>

        <div className="bza-modal-body">{children}</div>

        {footer && <div className="bza-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default Modal;
